module.exports = __webpack_public_path__ + "img/INTERIOR-S-CROSS-1.052b405c.jpg";